<!-- SeatLayout.vue -->
<template>
  <div class="seat-map-container">
    <div class="bus-info" :class="{ 'overnight-layout': isOvernight }">
      <!-- Layout xe thường -->
      <div v-if="!isOvernight" class="seat-grid" :style="gridStyle">
        <template v-for="seat in seatLayout" :key="seat.id">
          <div
            :class="[
              'seat',
              `seat-type-${seat.type}`,
              {
                'seat--selected': selectedSeats.includes(seat.id),
                'seat--standard': !isBooked(seat.id),
                'seat--unavailable': isBooked(seat.id),
                'seat--held': isHeld(seat.id),
                'seat--empty': seat.type === 'empty',
                'seat--driver': seat.type === 'driver',
                'seat--locked': isLockedSeat(seat.id),
                'seat--door': seat.type === 'door'
              }
            ]"
            :style="getSeatStyle(seat)"
            @click="handleSeatSelect(seat.id)"
          >
            <span v-if="seat.type === 'driver'" class="steering-wheel">
              <svg
                fill="#ffffff"
                height="25px"
                width="25px"
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 512 512"
                xml:space="preserve"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <g>
                    <g>
                      <path
                        d="M437.02,74.981C388.668,26.628,324.38,0,256,0S123.333,26.628,74.98,74.981C26.628,123.333,0,187.62,0,256 s26.628,132.667,74.98,181.019C123.333,485.372,187.62,512,256,512s132.667-26.628,181.02-74.981 C485.372,388.668,512,324.38,512,256S485.372,123.333,437.02,74.981z M256,57.263c100.782,0,184.276,75.409,197.04,172.765 L329.849,218.03c-13.813-26.755-41.72-45.102-73.849-45.102s-60.036,18.347-73.849,45.102L58.96,230.028 C71.724,132.672,155.218,57.263,256,57.263z M58.889,281.375l121.731,9.484c7.69,16.55,20.669,30.166,36.76,38.655l7.978,122.859 C138.513,438.875,70.099,368.943,58.889,281.375z M256,281.809c-14.232,0-25.809-11.578-25.809-25.809S241.77,230.191,256,230.191 S281.809,241.77,281.809,256S270.232,281.809,256,281.809z M286.644,452.373l7.978-122.859 c16.091-8.488,29.069-22.105,36.76-38.655l121.731-9.484C441.901,368.943,373.487,438.875,286.644,452.373z"
                      ></path>
                    </g>
                  </g>
                </g>
              </svg>
            </span>
            <span
              v-else-if="seat.id"
              class="seat-number"
              :class="{ 'booked-seat-number': isBooked(seat.id) }"
            >
              {{ seat.id }}
            </span>
            <span v-if="isLockedSeat(seat.id)" class="seat-lock-icon"><i class="fas fa-lock"></i></span>
          </div>
        </template>
      </div>

      <!-- Layout xe giường nằm -->
      <template v-else>
        <!-- Mobile Floor Tabs -->
        <div class="floor-tabs-mobile">
          <button 
            class="floor-tab" 
            :class="{ active: activeFloor === 'lower' }"
            @click="activeFloor = 'lower'"
          >
            Tầng 1
          </button>
          <button 
            class="floor-tab" 
            :class="{ active: activeFloor === 'upper' }"
            @click="activeFloor = 'upper'"
          >
            Tầng 2
          </button>
        </div>

        <!-- Mobile Carousel Container -->
        <div class="floor-carousel-mobile">
          <!-- Previous Arrow -->
          <button 
            class="floor-nav-btn floor-nav-prev" 
            @click="activeFloor = 'lower'"
            :class="{ invisible: activeFloor === 'lower' }"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="15,18 9,12 15,6"></polyline>
            </svg>
          </button>

          <!-- Floor Content -->
          <div class="floor-carousel-content">
            <!-- Lower Floor -->
            <div class="floor-slide" :class="{ active: activeFloor === 'lower' }">
              <div class="floor-section-mobile">
                <div class="seat-grid" :style="getOvernightGridStyle('under')">
                  <template v-for="seat in lowerDeckLayout" :key="seat.id">
                    <div
                      :class="[
                        'seat',
                        `seat-type-${seat.type}`,
                        {
                          'seat--selected': selectedSeats.includes(seat.id),
                          'seat--standard': !isBooked(seat.id),
                          'seat--unavailable': isBooked(seat.id),
                          'seat--held': isHeld(seat.id),
                          'seat--empty': seat.type === 'empty',
                          'seat--driver': seat.type === 'driver',
                          'seat--locked': isLockedSeat(seat.id),
                          'seat--door': seat.type === 'door'
                        }
                      ]"
                      :style="getSeatStyle(seat)"
                      @click="handleSeatSelect(seat.id)"
                    >
                      <span v-if="seat.type === 'driver'" class="steering-wheel">
                        <svg fill="#ffffff" height="20px" width="20px" viewBox="0 0 512 512">
                          <path d="M437.02,74.981C388.668,26.628,324.38,0,256,0S123.333,26.628,74.98,74.981C26.628,123.333,0,187.62,0,256 s26.628,132.667,74.98,181.019C123.333,485.372,187.62,512,256,512s132.667-26.628,181.02-74.981 C485.372,388.668,512,324.38,512,256S485.372,123.333,437.02,74.981z M256,57.263c100.782,0,184.276,75.409,197.04,172.765 L329.849,218.03c-13.813-26.755-41.72-45.102-73.849-45.102s-60.036,18.347-73.849,45.102L58.96,230.028 C71.724,132.672,155.218,57.263,256,57.263z M58.889,281.375l121.731,9.484c7.69,16.55,20.669,30.166,36.76,38.655l7.978,122.859 C138.513,438.875,70.099,368.943,58.889,281.375z M256,281.809c-14.232,0-25.809-11.578-25.809-25.809S241.77,230.191,256,230.191 S281.809,241.77,281.809,256S270.232,281.809,256,281.809z M286.644,452.373l7.978-122.859 c16.091-8.488,29.069-22.105,36.76-38.655l121.731-9.484C441.901,368.943,373.487,438.875,286.644,452.373z"/>
                        </svg>
                      </span>
                      <span v-else-if="seat.id" class="seat-number" :class="{ 'booked-seat-number': isBooked(seat.id) }">
                        {{ seat.id }}
                      </span>
                      <span v-if="isLockedSeat(seat.id)" class="seat-lock-icon"><i class="fas fa-lock"></i></span>
                    </div>
                  </template>
                </div>
              </div>
            </div>

            <!-- Upper Floor -->
            <div class="floor-slide" :class="{ active: activeFloor === 'upper' }">
              <div class="floor-section-mobile">
                <div class="seat-grid" :style="getOvernightGridStyle('upper')">
                  <template v-for="seat in upperDeckLayout" :key="seat.id">
                    <div
                      :class="[
                        'seat',
                        `seat-type-${seat.type}`,
                        {
                          'seat--selected': selectedSeats.includes(seat.id),
                          'seat--standard': !isBooked(seat.id),
                          'seat--unavailable': isBooked(seat.id),
                          'seat--held': isHeld(seat.id),
                          'seat--empty': seat.type === 'empty',
                          'seat--locked': isLockedSeat(seat.id),
                          'seat--driver': seat.type === 'driver'
                        }
                      ]"
                      :style="getSeatStyle(seat)"
                      @click="handleSeatSelect(seat.id)"
                    >
                      <span v-if="seat.id" class="seat-number" :class="{ 'booked-seat-number': isBooked(seat.id) }">
                        {{ seat.id }}
                      </span>
                      <span v-if="isLockedSeat(seat.id)" class="seat-lock-icon"><i class="fas fa-lock"></i></span>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>

          <!-- Next Arrow -->
          <button 
            class="floor-nav-btn floor-nav-next" 
            @click="activeFloor = 'upper'"
            :class="{ invisible: activeFloor === 'upper' }"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="9,6 15,12 9,18"></polyline>
            </svg>
          </button>
        </div>

        <!-- Desktop Layout (hidden on mobile) -->
        <div class="desktop-floors">
          <!-- Tầng dưới -->
          <div class="floor-section">
            <h3 class="floor-title">Tầng dưới</h3>
            <div class="seat-grid" :style="getOvernightGridStyle('under')">
              <template v-for="seat in lowerDeckLayout" :key="seat.id">
                <div
                  :class="[
                    'seat',
                    `seat-type-${seat.type}`,
                    {
                      'seat--selected': selectedSeats.includes(seat.id),
                      'seat--standard': !isBooked(seat.id),
                      'seat--unavailable': isBooked(seat.id),
                      'seat--held': isHeld(seat.id),
                      'seat--empty': seat.type === 'empty',
                      'seat--driver': seat.type === 'driver',
                      'seat--locked': isLockedSeat(seat.id),
                      'seat--door': seat.type === 'door'
                    }
                  ]"
                  :style="getSeatStyle(seat)"
                  @click="handleSeatSelect(seat.id)"
                >
                  <span v-if="seat.type === 'driver'" class="steering-wheel">
                    <svg fill="#ffffff" height="25px" width="25px" viewBox="0 0 512 512">
                      <path d="M437.02,74.981C388.668,26.628,324.38,0,256,0S123.333,26.628,74.98,74.981C26.628,123.333,0,187.62,0,256 s26.628,132.667,74.98,181.019C123.333,485.372,187.62,512,256,512s132.667-26.628,181.02-74.981 C485.372,388.668,512,324.38,512,256S485.372,123.333,437.02,74.981z M256,57.263c100.782,0,184.276,75.409,197.04,172.765 L329.849,218.03c-13.813-26.755-41.72-45.102-73.849-45.102s-60.036,18.347-73.849,45.102L58.96,230.028 C71.724,132.672,155.218,57.263,256,57.263z M58.889,281.375l121.731,9.484c7.69,16.55,20.669,30.166,36.76,38.655l7.978,122.859 C138.513,438.875,70.099,368.943,58.889,281.375z M256,281.809c-14.232,0-25.809-11.578-25.809-25.809S241.77,230.191,256,230.191 S281.809,241.77,281.809,256S270.232,281.809,256,281.809z M286.644,452.373l7.978-122.859 c16.091-8.488,29.069-22.105,36.76-38.655l121.731-9.484C441.901,368.943,373.487,438.875,286.644,452.373z"/>
                    </svg>
                  </span>
                  <span v-else-if="seat.id" class="seat-number" :class="{ 'booked-seat-number': isBooked(seat.id) }">
                    {{ seat.id }}
                  </span>
                  <span v-if="isLockedSeat(seat.id)" class="seat-lock-icon"><i class="fas fa-lock"></i></span>
                </div>
              </template>
            </div>
          </div>

          <!-- Tầng trên -->
          <div class="floor-section">
            <h3 class="floor-title">Tầng trên</h3>
            <div class="seat-grid" :style="getOvernightGridStyle('upper')">
              <template v-for="seat in upperDeckLayout" :key="seat.id">
                <div
                  :class="[
                    'seat',
                    `seat-type-${seat.type}`,
                    {
                      'seat--selected': selectedSeats.includes(seat.id),
                      'seat--standard': !isBooked(seat.id),
                      'seat--unavailable': isBooked(seat.id),
                      'seat--held': isHeld(seat.id),
                      'seat--empty': seat.type === 'empty',
                      'seat--locked': isLockedSeat(seat.id),
                      'seat--driver': seat.type === 'driver'
                    }
                  ]"
                  :style="getSeatStyle(seat)"
                  @click="handleSeatSelect(seat.id)"
                >
                  <span v-if="seat.id" class="seat-number" :class="{ 'booked-seat-number': isBooked(seat.id) }">
                    {{ seat.id }}
                  </span>
                  <span v-if="isLockedSeat(seat.id)" class="seat-lock-icon"><i class="fas fa-lock"></i></span>
                </div>
              </template>
            </div>
          </div>
        </div>
      </template>
    </div>

    <!-- Enhanced Legend -->
    <div class="seat-legend">
      <div v-for="item in legendItems" :key="item.type" class="legend-item">
        <div :class="['legend-color', `legend-color--${item.type}`]"></div>
        <div class="legend-label">{{ item.label }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SeatLayout',
  props: {
    vehicleType: {
      type: String,
      required: true
    },
    selectedSeats: {
      type: Array,
      default: () => []
    },
    bookedSeats: {
      type: Array,
      default: () => []
    },
    heldSeats: {
      type: Array,
      default: () => []
    },
    lockedSeats: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      activeFloor: 'lower', // For mobile floor carousel
      legendItems: [
        { type: 'standard', label: 'Ghế trống' },
        { type: 'selected', label: 'Ghế đã chọn' },
        { type: 'unavailable', label: 'Ghế đã đặt' },
        { type: 'held', label: 'Ghế đang giữ' }
      ],
      layoutConfigs: {
        '16_slots': {
          rows: 5, // Điều chỉnh số hàng và cột cho layout dọc
          cols: 4,
          layout: [
            { id: 0, type: 'driver', col: 1, row: 1 },
            { id: 0, type: 'empty', col: 2, row: 1 },
            { id: 2, type: 'seat', col: 3, row: 1 },
            { id: 1, type: 'seat', col: 4, row: 1 },
            { id: 5, type: 'seat', col: 1, row: 2 },
            { id: 4, type: 'seat', col: 2, row: 2 },
            { id: 3, type: 'seat', col: 3, row: 2 },
            { id: 0, type: 'door', col: 4, row: 2 },
            { id: 8, type: 'seat', col: 1, row: 3 },
            { id: 7, type: 'seat', col: 2, row: 3 },
            { id: 0, type: 'empty', col: 3, row: 3 },
            { id: 6, type: 'seat', col: 4, row: 3 },
            { id: 11, type: 'seat', col: 1, row: 4 },
            { id: 10, type: 'seat', col: 2, row: 4 },
            { id: 0, type: 'empty', col: 3, row: 4 },
            { id: 9, type: 'seat', col: 4, row: 4 },
            { id: 15, type: 'seat', col: 1, row: 5 },
            { id: 14, type: 'seat', col: 2, row: 5 },
            { id: 13, type: 'seat', col: 3, row: 5 },
            { id: 12, type: 'seat', col: 4, row: 5 }
          ]
        },
        '28_slots': {
          // Thêm layout cho xe 28 chỗ
          rows: 8,
          cols: 6,
          layout: [
            { id: null, type: 'driver', col: 1, row: 1 },
            { id: null, type: 'empty', col: 2, row: 1 },
            { id: null, type: 'empty', col: 2, row: 1 },
            { id: null, type: 'door', col: 6, row: 1 },
            { id: 1, type: 'seat', col: 1, row: 2 },
            { id: 2, type: 'seat', col: 2, row: 2 },
            { id: null, type: 'empty', col: 3, row: 2 },
            { id: null, type: 'empty', col: 4, row: 2 },
            { id: 3, type: 'seat', col: 5, row: 2 },
            { id: 4, type: 'seat', col: 6, row: 2 },
            { id: 5, type: 'seat', col: 1, row: 3 },
            { id: 6, type: 'seat', col: 2, row: 3 },
            { id: null, type: 'empty', col: 3, row: 3 },
            { id: null, type: 'empty', col: 4, row: 3 },
            { id: 7, type: 'seat', col: 5, row: 3 },
            { id: 8, type: 'seat', col: 6, row: 3 },
            { id: 9, type: 'seat', col: 1, row: 4 },
            { id: 10, type: 'seat', col: 2, row: 4 },
            { id: null, type: 'empty', col: 3, row: 4 },
            { id: null, type: 'empty', col: 4, row: 4 },
            { id: 11, type: 'seat', col: 5, row: 4 },
            { id: 12, type: 'seat', col: 6, row: 4 },
            { id: 13, type: 'seat', col: 1, row: 5 },
            { id: 14, type: 'seat', col: 2, row: 5 },
            { id: null, type: 'empty', col: 3, row: 5 },
            { id: null, type: 'empty', col: 4, row: 5 },
            { id: 15, type: 'seat', col: 5, row: 5 },
            { id: 16, type: 'seat', col: 6, row: 5 },
            { id: 17, type: 'seat', col: 1, row: 6 },
            { id: 18, type: 'seat', col: 2, row: 6 },
            { id: null, type: 'empty', col: 3, row: 6 },
            { id: null, type: 'empty', col: 4, row: 6 },
            { id: 19, type: 'seat', col: 5, row: 6 },
            { id: 20, type: 'seat', col: 6, row: 6 },
            { id: 21, type: 'seat', col: 1, row: 7 },
            { id: 22, type: 'seat', col: 2, row: 7 },
            { id: null, type: 'empty', col: 3, row: 7 },
            { id: null, type: 'empty', col: 4, row: 7 },
            { id: 23, type: 'seat', col: 5, row: 7 },
            { id: 24, type: 'seat', col: 6, row: 7 },
            { id: 25, type: 'seat', col: 2, row: 8 },
            { id: 26, type: 'seat', col: 3, row: 8 },
            { id: 27, type: 'seat', col: 4, row: 8 },
            { id: 28, type: 'seat', col: 5, row: 8 }
          ]
        },
        '45_slots': {
          rows: 12, // Điều chỉnh rows và cols cho phù hợp
          cols: 5,
          layout: [
            { id: null, type: 'driver', col: 1, row: 1 },
            { id: null, type: 'door', col: 5, row: 1 },
            { id: 1, type: 'seat', col: 1, row: 2 },
            { id: 2, type: 'seat', col: 2, row: 2 },
            { id: null, type: 'empty', col: 3, row: 2 },
            { id: 3, type: 'seat', col: 4, row: 2 },
            { id: 4, type: 'seat', col: 5, row: 2 },
            { id: 5, type: 'seat', col: 1, row: 3 },
            { id: 6, type: 'seat', col: 2, row: 3 },
            { id: null, type: 'empty', col: 3, row: 3 },
            { id: 7, type: 'seat', col: 4, row: 3 },
            { id: 8, type: 'seat', col: 5, row: 3 },
            { id: 9, type: 'seat', col: 1, row: 4 },
            { id: 10, type: 'seat', col: 2, row: 4 },
            { id: null, type: 'empty', col: 3, row: 4 },
            { id: 11, type: 'seat', col: 4, row: 4 },
            { id: 12, type: 'seat', col: 5, row: 4 },
            { id: 13, type: 'seat', col: 1, row: 5 },
            { id: 14, type: 'seat', col: 2, row: 5 },
            { id: null, type: 'empty', col: 3, row: 5 },
            { id: 15, type: 'seat', col: 4, row: 5 },
            { id: 16, type: 'seat', col: 5, row: 5 },
            { id: 17, type: 'seat', col: 1, row: 6 },
            { id: 18, type: 'seat', col: 2, row: 6 },
            { id: null, type: 'empty', col: 3, row: 6 },
            { id: 19, type: 'seat', col: 4, row: 6 },
            { id: 20, type: 'seat', col: 5, row: 6 },
            { id: 21, type: 'seat', col: 1, row: 7 },
            { id: 22, type: 'seat', col: 2, row: 7 },
            { id: null, type: 'empty', col: 3, row: 7 },
            { id: 23, type: 'seat', col: 4, row: 7 },
            { id: 24, type: 'seat', col: 5, row: 7 },
            { id: 25, type: 'seat', col: 1, row: 8 },
            { id: 26, type: 'seat', col: 2, row: 8 },
            { id: null, type: 'empty', col: 3, row: 8 },
            { id: 27, type: 'seat', col: 4, row: 8 },
            { id: 28, type: 'seat', col: 5, row: 8 },
            { id: 29, type: 'seat', col: 1, row: 9 },
            { id: 30, type: 'seat', col: 2, row: 9 },
            { id: null, type: 'empty', col: 3, row: 9 },
            { id: 31, type: 'seat', col: 4, row: 9 },
            { id: 32, type: 'seat', col: 5, row: 9 },
            { id: 33, type: 'seat', col: 1, row: 10 },
            { id: 34, type: 'seat', col: 2, row: 10 },
            { id: null, type: 'empty', col: 3, row: 10 },
            { id: 35, type: 'seat', col: 4, row: 10 },
            { id: 36, type: 'seat', col: 5, row: 10 },
            { id: 37, type: 'seat', col: 1, row: 11 },
            { id: 38, type: 'seat', col: 2, row: 11 },
            { id: null, type: 'empty', col: 3, row: 11 },
            { id: 39, type: 'seat', col: 4, row: 11 },
            { id: 40, type: 'seat', col: 5, row: 11 },
            { id: 41, type: 'seat', col: 1, row: 12 },
            { id: 42, type: 'seat', col: 2, row: 12 },
            { id: 43, type: 'seat', col: 3, row: 12 },
            { id: 44, type: 'seat', col: 4, row: 12 },
            { id: 45, type: 'seat', col: 5, row: 12 }
          ]
        },
        over_night_under: {
          // Xe giường nằm, 2 tầng
          rows: 8,
          cols: 5,
          layout: [
            // Tầng dưới
            { id: null, type: 'driver', col: 1, row: 1 },
            { id: null, type: 'empty', col: 2, row: 1 },
            { id: null, type: 'door', col: 5, row: 1 },
            { id: '13A', type: 'seat', col: 1, row: 2 },
            { id: null, type: 'empty', col: 2, row: 2 },
            { id: '7A', type: 'seat', col: 3, row: 2 },
            { id: null, type: 'empty', col: 4, row: 2 },
            { id: '1A', type: 'seat', col: 5, row: 2 },
            { id: '14A', type: 'seat', col: 1, row: 3 },
            { id: null, type: 'empty', col: 2, row: 3 },
            { id: '8A', type: 'seat', col: 3, row: 3 },
            { id: null, type: 'empty', col: 4, row: 3 },
            { id: '2A', type: 'seat', col: 5, row: 3 },
            { id: '15A', type: 'seat', col: 1, row: 4 },
            { id: null, type: 'empty', col: 2, row: 4 },
            { id: '9A', type: 'seat', col: 3, row: 4 },
            { id: null, type: 'empty', col: 4, row: 4 },
            { id: '3A', type: 'seat', col: 5, row: 4 },
            { id: '16A', type: 'seat', col: 1, row: 5 },
            { id: null, type: 'empty', col: 2, row: 5 },
            { id: '10A', type: 'seat', col: 3, row: 5 },
            { id: null, type: 'empty', col: 4, row: 5 },
            { id: '4A', type: 'seat', col: 5, row: 5 },
            { id: '17A', type: 'seat', col: 1, row: 6 },
            { id: null, type: 'empty', col: 2, row: 6 },
            { id: '11A', type: 'seat', col: 3, row: 6 },
            { id: null, type: 'empty', col: 4, row: 6 },
            { id: '5A', type: 'seat', col: 5, row: 6 },
            { id: '18A', type: 'seat', col: 1, row: 7 },
            { id: null, type: 'empty', col: 2, row: 7 },
            { id: null, type: 'empty', col: 3, row: 7 },
            { id: null, type: 'empty', col: 4, row: 7 },
            { id: '6A', type: 'seat', col: 5, row: 7 },
            { id: '23A', type: 'seat', col: 1, row: 8 },
            { id: '22A', type: 'seat', col: 2, row: 8 },
            { id: '21A', type: 'seat', col: 3, row: 8 },
            { id: '20A', type: 'seat', col: 4, row: 8 },
            { id: '19A', type: 'seat', col: 5, row: 8 }
          ]
        },
        over_night_upper: {
          // Xe giường nằm, 2 tầng
          rows: 8,
          cols: 5,
          layout: [
            // Tầng trên
            { id: '13B', type: 'seat', col: 1, row: 2 },
            { id: null, type: 'empty', col: 2, row: 2 },
            { id: '7B', type: 'seat', col: 3, row: 2 },
            { id: null, type: 'empty', col: 4, row: 2 },
            { id: '1B', type: 'seat', col: 5, row: 2 },
            { id: '14B', type: 'seat', col: 1, row: 3 },
            { id: null, type: 'empty', col: 2, row: 3 },
            { id: '8B', type: 'seat', col: 3, row: 3 },
            { id: null, type: 'empty', col: 4, row: 3 },
            { id: '2B', type: 'seat', col: 5, row: 3 },
            { id: '15B', type: 'seat', col: 1, row: 4 },
            { id: null, type: 'empty', col: 2, row: 4 },
            { id: '9B', type: 'seat', col: 3, row: 4 },
            { id: null, type: 'empty', col: 4, row: 4 },
            { id: '3B', type: 'seat', col: 5, row: 4 },
            { id: '16B', type: 'seat', col: 1, row: 5 },
            { id: null, type: 'empty', col: 2, row: 5 },
            { id: '10B', type: 'seat', col: 3, row: 5 },
            { id: null, type: 'empty', col: 4, row: 5 },
            { id: '4B', type: 'seat', col: 5, row: 5 },
            { id: '17B', type: 'seat', col: 1, row: 6 },
            { id: null, type: 'empty', col: 2, row: 6 },
            { id: '11B', type: 'seat', col: 3, row: 6 },
            { id: null, type: 'empty', col: 4, row: 6 },
            { id: '5B', type: 'seat', col: 5, row: 6 },
            { id: '18B', type: 'seat', col: 1, row: 7 },
            { id: null, type: 'empty', col: 2, row: 7 },
            { id: null, type: 'empty', col: 3, row: 7 },
            { id: null, type: 'empty', col: 4, row: 7 },
            { id: '6B', type: 'seat', col: 5, row: 7 },
            { id: '23B', type: 'seat', col: 1, row: 8 },
            { id: '22B', type: 'seat', col: 2, row: 8 },
            { id: '21B', type: 'seat', col: 3, row: 8 },
            { id: '20B', type: 'seat', col: 4, row: 8 },
            { id: '19B', type: 'seat', col: 5, row: 8 }
          ]
        }
      }
    }
  },
  computed: {
    isOvernight () {
      return this.vehicleType === 'over_night'
    },
    currentLayout () {
      if (!this.isOvernight) {
        return (
          this.layoutConfigs[this.vehicleType] || this.layoutConfigs['16_slots']
        )
      }
      return null
    },
    lowerDeckLayout () {
      return this.layoutConfigs['over_night_under'].layout
    },
    upperDeckLayout () {
      return this.layoutConfigs['over_night_upper'].layout
    },
    gridStyle () {
      const layout = this.currentLayout
      return {
        display: 'grid',
        gridTemplateColumns: `repeat(${layout.cols}, 1fr)`,
        gridTemplateRows: `repeat(${layout.rows}, 1fr)`,
        gap: '0.5rem',
        margin: '1rem auto'
      }
    },
    seatLayout () {
      return this.currentLayout ? this.currentLayout.layout : []
    }
  },
  methods: {
    getOvernightGridStyle (floor) {
      const config =
        floor === 'under'
          ? this.layoutConfigs['over_night_under']
          : this.layoutConfigs['over_night_upper']

      // Determine if we're on a small screen
      const isMobile = window.innerWidth <= 640

      return {
        display: 'grid',
        gridTemplateColumns: `repeat(${config.cols}, ${
          isMobile ? '1fr' : '1fr'
        })`,
        gridTemplateRows: `repeat(${config.rows}, ${isMobile ? '1fr' : '1fr'})`,
        gap: isMobile ? '0.25rem' : '0.5rem',
        margin: '0.5rem auto',
        width: 'fit-content' // Ensure it doesn't overflow
      }
    },
    getSeatStyle (seat) {
      return {
        gridColumn: seat.col,
        gridRow: seat.row
      }
    },
    handleSeatSelect (seatId) {
      if (
        !seatId ||
        this.isBooked(seatId) ||
        this.isHeld(seatId)
      ) {
        return
      }
      this.$emit('seat-selected', seatId)
    },
    isBooked (seatId) {
      if (!seatId) return false
      const seatIdString = seatId.toString()
      const result = this.bookedSeats.includes(seatIdString)

      return result
    },
    isHeld (seatId) {
      if (!seatId) return false
      // Convert seatId to string for consistent comparison
      const seatIdString = seatId.toString()
      const isHeld = this.heldSeats.includes(seatIdString)
      return isHeld
    },

    isLockedSeat (seatId) {
      if (!seatId) return false
      const seatIdString = seatId.toString()
      const lockedSeats = this.lockedSeats.map(seat => seat.toString())
      return lockedSeats.includes(seatIdString)
    }
  },
  mounted () {
    // For overnight layouts, log both upper and lower deck seats
    if (this.isOvernight) {
      const allOvernightSeats = [
        ...this.lowerDeckLayout
          .filter(seat => seat.type === 'seat')
          .map(seat => seat.id),
        ...this.upperDeckLayout
          .filter(seat => seat.type === 'seat')
          .map(seat => seat.id)
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.seat-selection {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2rem auto;
}

.seat-map-container {
  padding: 1rem;
  background: #f8fafc;
  border-radius: 0.75rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, sans-serif;
  justify-content: center;
  align-items: center;

  /* Add this to ensure proper mobile behavior */
  overflow-x: hidden;
}

.bus-info {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.seat-grid {
  display: grid;
  gap: 0.75rem;
  width: fit-content;
  padding: 1.5rem;
  background: white;
  border-radius: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.seat {
  aspect-ratio: 1 / 1.3; /* Less tall than before (was 1/2) */
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0.5rem;
  min-width: 2.5rem;
  min-height: 2.5rem;
  font-size: 0.875rem;
  letter-spacing: -0.025em;

  &:hover:not(.seat--unavailable):not(.seat--empty):not(.seat--driver):not(.seat--door):not(.seat--held) {
    transform: translateY(-2px);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
      0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  &--standard {
    background: #3b82f6;
    color: white;

    &:hover:not(.seat--unavailable):not(.seat--empty):not(.seat--driver):not(.seat--door):not(.seat--held) {
      background: #14c24b;
    }
  }

  &--selected {
    background: #0ed112;
    color: white;
    box-shadow: 0 4px 6px -1px rgba(139, 92, 246, 0.3);

    &:hover {
      background: #14c24b;
    }
  }

  &--unavailable {
    background: #c0c0c1; /* Use gray background instead of flag */
    color: #94a3b8;
    cursor: not-allowed;
  }

  &--held {
    background: #f1b687; // Màu cam cho ghế đang giữ
    color: white;
    cursor: not-allowed;
  }

  &--locked {
    background: #64748b; // Màu xám đậm hơn để phân biệt
    color: white;
    cursor: pointer;
    position: relative;
    &:hover {
      opacity: 0.8;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    }
  }

  .seat-lock-icon {
    position: absolute;
    top: 2px;
    right: 3px;
    font-size: 8px;
    opacity: 0.85;
    pointer-events: none;
    line-height: 1;
  }

  &--empty {
    background: transparent;
    pointer-events: none;
    border: none;
  }

  &--driver {
    background: #475569;
    color: white;
    cursor: not-allowed;
    pointer-events: none;

    .steering-wheel {
      width: 24px;
      height: 24px;

      svg {
        stroke-width: 1.5;
        stroke: currentColor;
      }
    }
  }

  &--door {
    background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
    pointer-events: none;
    position: relative;
    cursor: default;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px dashed #94a3b8;
    border-radius: 0.5rem;

    &::after {
      content: 'Cửa';
      font-size: 0.7rem;
      font-weight: 600;
      color: #64748b;
      letter-spacing: 0.025em;
    }
  }
}

/* Remove Vietnam flag styling */
.vietnam-flag {
  display: none; /* Hide the flag completely */
}

.booked-seat-number {
  color: white;
}

.overnight-layout {
  display: flex;
  flex-direction: row;
  gap: 2rem;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  margin: 0 auto;
}

.floor-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  //min-width: 280px;
  flex: 1;
  //max-width: 500px;
  margin: 0 auto;
  justify-content: center;
}

.floor-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 1rem;
  text-align: center;
  padding: 0.5rem 1rem;
  background: #f1f5f9;
  border-radius: 0.5rem;
  width: fit-content;
}

.seat-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 2rem;
  justify-content: center;
  padding: 1rem;
  background: white;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 1rem;
  background: #f8fafc;
  border-radius: 0.375rem;
  min-width: 140px;
}

.legend-color {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 0.375rem;

  &--locked {
    background: #64748b;
  }

  &--standard {
    background: #3b82f6;
    box-shadow: 0 2px 4px rgba(59, 130, 246, 0.2);
  }

  &--selected {
    background: #0ed112;
    box-shadow: 0 2px 4px rgba(139, 92, 246, 0.2);
  }

  &--unavailable {
    background: #c0c0c1; /* Use gray background */
    position: relative;
    overflow: hidden;
  }

  &--held {
    background: #f1b687;
    box-shadow: 0 2px 4px rgba(237, 137, 54, 0.2);
  }

  &--driver {
    background: #475569;
  }

  &--door {
    background: transparent;
    pointer-events: none;
    position: relative;
    cursor: default;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      width: 4px;
      background: repeating-linear-gradient(135deg, #f6e05e, #f6e05e 5px);
      transform: skew(15deg);
      transform-origin: top;
    }
  }
}

/* Remove the flag styling from legend */
.legend-color--unavailable::before,
.legend-color--unavailable::after {
  display: none;
}

.legend-label {
  color: #1e293b;
  font-size: 0.875rem;
  font-weight: 500;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, sans-serif;
}

.seat-number {
  font-weight: 600;
  font-size: 0.875rem;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, sans-serif;
}

@media (max-width: 640px) {
  /* Hide desktop floors on mobile */
  .desktop-floors {
    display: none !important;
  }

  /* Show mobile elements */
  .floor-tabs-mobile,
  .floor-carousel-mobile {
    display: flex;
  }

  /* Floor Tabs */
  .floor-tabs-mobile {
    display: flex;
    justify-content: center;
    gap: 0;
    margin-bottom: 0.75rem;
    background: #f1f5f9;
    border-radius: 0.5rem;
    padding: 0.25rem;
    width: fit-content;
    margin-left: auto;
    margin-right: auto;
  }

  .floor-tab {
    padding: 0.5rem 1.25rem;
    border: none;
    background: transparent;
    color: #64748b;
    font-weight: 600;
    font-size: 0.875rem;
    cursor: pointer;
    border-radius: 0.375rem;
    transition: all 0.2s ease;
  }

  .floor-tab.active {
    background: white;
    color: #2563eb;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  /* Floor Carousel */
  .floor-carousel-mobile {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    position: relative;
    width: 100%;
  }

  .floor-nav-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    border: 1px solid #e2e8f0;
    background: white;
    border-radius: 50%;
    color: #475569;
    cursor: pointer;
    transition: all 0.2s ease;
    flex-shrink: 0;
  }

  .floor-nav-btn:hover {
    background: #f1f5f9;
    border-color: #cbd5e1;
  }

  .floor-nav-btn.invisible {
    opacity: 0;
    pointer-events: none;
  }

  .floor-carousel-content {
    position: relative;
    overflow: visible; /* Allow content to be fully visible */
    width: 100%;
    max-width: 100%; /* Allow full width */
    display: flex;
    justify-content: center;
  }

  .floor-slide {
    display: none; /* Hidden by default */
    animation: slideIn 0.2s ease;
    width: 100%; /* Take full available width */
    justify-content: center;
  }

  .floor-slide.active {
    display: flex; /* Only show active floor */
  }

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateX(10px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  .floor-section-mobile {
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 0.75rem;
    padding: 0.75rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    width: fit-content;
    min-width: 240px; /* Minimum reasonable width */
  }

  /* Seat Grid */
  .seat-map-container {
    width: 100%;
    padding: 0; /* Remove padding for edge-to-edge feel if needed, or keep small */
    margin: 0 auto;
    background: transparent;
    box-shadow: none; /* Remove subtle shadow on container for cleaner mobile look */
  }

  .seat-grid {
    gap: 0.25rem;
    padding: 0.25rem;
    min-width: unset;
    width: fit-content;
    margin: 0 auto;
  }

  .seat {
    width: 2rem;
    height: 2.5rem;
    min-width: 2rem;
    min-height: 2rem;
    padding: 0.1rem;
    font-size: 0.6rem;
    border-radius: 0.25rem;
    flex-shrink: 0;
    aspect-ratio: 1 / 1.25; /* Slightly taller than wide */
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .seat-number {
    font-size: 0.6rem;
  }

  .steering-wheel svg {
    width: 16px;
    height: 16px;
  }

  /* Compact legend for mobile */
  .seat-legend {
    display: grid;
    grid-template-columns: repeat(2, 1fr); /* 2 columns grid */
    gap: 0.5rem;
    padding: 0.75rem;
    margin-top: 1rem;
    background: white;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }

  .legend-item {
    padding: 0.25rem 0.5rem;
    gap: 0.5rem;
    font-size: 0.75rem;
    min-width: unset; /* Remove min-width constraint */
    justify-content: flex-start;
  }

  .legend-color {
    width: 1rem;
    height: 1rem;
    flex-shrink: 0;
  }

  .legend-label {
    font-size: 0.75rem;
    white-space: normal; /* Allow text wrapping */
    text-align: left;
  }
}

/* Desktop: hide mobile elements, show desktop floors */
@media (min-width: 641px) {
  .floor-tabs-mobile,
  .floor-carousel-mobile {
    display: none !important;
  }

  .desktop-floors {
    display: flex;
    flex-direction: row;
    gap: 1.5rem;
  }
}

/* Very small screens */
@media (max-width: 380px) {
  .floor-section-mobile {
     padding: 0.5rem;
     min-width: unset;
  }

  .seat {
    min-width: 1.75rem;
    min-height: 1.75rem;
    width: 1.75rem;
    height: 1.75rem;
    font-size: 0.55rem;
  }

  .floor-tab {
    padding: 0.4rem 1rem;
    font-size: 0.8rem;
  }
  
  .seat-legend {
      grid-template-columns: repeat(2, 1fr);
      gap: 0.25rem;
  }
}
</style>
